(() => {
  'use strict';

  const labelIconControls = (root = document) => {
    const labels = [
      ['.t4s-push-menu-btn', 'Abrir menú'],
      ['.t4s-site-nav__search a', 'Buscar'],
      ['.t4s-site-nav__cart a', 'Abrir carrito'],
      ['#start-chat-link', 'Abrir chat de asesoría por WhatsApp'],
      ['[data-layout-switch] button[data-col="1"]', 'Mostrar 1 producto por fila'],
      ['[data-layout-switch] button[data-col="2"]', 'Mostrar 2 productos por fila'],
      ['[data-layout-switch] button[data-col="3"]', 'Mostrar 3 productos por fila'],
      ['[data-layout-switch] button[data-col="4"]', 'Mostrar 4 productos por fila'],
      ['.flickityt4s-prev-next-button.previous', 'Anterior'],
      ['.flickityt4s-prev-next-button.next', 'Siguiente']
    ];

    labels.forEach(([selector, label]) => {
      const controls = root.matches?.(selector)
        ? [root]
        : Array.from(root.querySelectorAll?.(selector) || []);

      controls.forEach((control) => {
        if (!control.hasAttribute('aria-label')) control.setAttribute('aria-label', label);
      });
    });

    const quickShopSelector = 'body.template-collection .t4s-main-collection-page a[data-action-quickshop]';
    const quickShopActions = root.matches?.(quickShopSelector)
      ? [root]
      : Array.from(root.querySelectorAll?.(quickShopSelector) || []);

    quickShopActions.forEach((control) => {
      control.setAttribute('aria-label', 'Elegir talla');
      const text = control.querySelector('.t4s-text-pr');
      if (text) text.textContent = 'Elegir talla';
    });

    const productActionSelector = '.t4s-pr-addtocart, .t4s-pr-quickview';
    const productActions = root.matches?.(productActionSelector)
      ? [root]
      : Array.from(root.querySelectorAll?.(productActionSelector) || []);

    productActions.forEach((control) => {
      if (control.hasAttribute('aria-label') || !control.matches('a, button')) return;

      const actionText = control.querySelector('.t4s-text-pr')?.textContent.trim();
      if (actionText) control.setAttribute('aria-label', actionText);
    });

    const decorativeVideoFallbacks = root.matches?.('.t4s_bg_vid_html5 img:not([alt])')
      ? [root]
      : Array.from(root.querySelectorAll?.('.t4s_bg_vid_html5 img:not([alt])') || []);

    decorativeVideoFallbacks.forEach((image) => image.setAttribute('alt', ''));
  };

  const syncMenuDisclosureState = () => {
    const drawer = document.querySelector('#t4s-menu-drawer');
    const isOpen = drawer?.getAttribute('aria-hidden') === 'false';

    document.querySelectorAll('[data-menu-drawer]').forEach((trigger) => {
      trigger.setAttribute('aria-controls', 't4s-menu-drawer');
      trigger.setAttribute('aria-expanded', String(Boolean(isOpen)));
    });
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest?.('[data-menu-drawer]')) event.preventDefault();
  }, true);

  const listingStateKey = (entries) =>
    entries
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .sort()
      .join('&');

  const isListingStateParam = (key) =>
    key.startsWith('filter.') ||
    key === 'sort_by' ||
    key === 'q' ||
    key === 'type' ||
    key.startsWith('options[');

  const currentListingState = () => {
    const current = new URL(window.location.href);
    return Array.from(current.searchParams.entries()).filter(([key]) =>
      isListingStateParam(key)
    );
  };

  const hasSameListingState = (candidate) => {
    const actual = Array.from(candidate.searchParams.entries()).filter(([key]) =>
      isListingStateParam(key)
    );

    return listingStateKey(currentListingState()) === listingStateKey(actual);
  };

  const correctLoadMoreHref = (loadMore) => {
    const href = loadMore.getAttribute('href');
    if (!href) return;

    const requested = new URL(href, window.location.origin);
    if (hasSameListingState(requested)) return;

    const corrected = new URL(window.location.href);
    corrected.searchParams.set('page', requested.searchParams.get('page') || '2');
    loadMore.href = corrected.toString();
  };

  const syncLoadMoreState = (root = document) => {
    const controls = root.matches?.('[data-load-more]')
      ? [root]
      : Array.from(root.querySelectorAll?.('[data-load-more]') || []);

    controls.forEach(correctLoadMoreHref);
  };

  const syncCartCountBadges = (root = document) => {
    if (!root) return;

    const badges = root.matches?.('[data-cart-count]')
      ? [root]
      : Array.from(root.querySelectorAll?.('[data-cart-count]') || []);

    badges.forEach((badge) => {
      const count = Number.parseInt(badge.textContent.trim(), 10);
      const hasItems = Number.isFinite(count) && count > 0;

      badge.dataset.cartCountValue = hasItems ? String(count) : '0';
      badge.hidden = !hasItems;
      badge.setAttribute('aria-hidden', String(!hasItems));
    });
  };

  const syncLayoutSwitchState = (root = document) => {
    const switches = new Set(root.querySelectorAll?.('[data-layout-switch]') || []);
    if (root.matches?.('[data-layout-switch]')) switches.add(root);

    const parentSwitch = root.closest?.('[data-layout-switch]');
    if (parentSwitch) switches.add(parentSwitch);

    switches.forEach((layoutSwitch) => {
      layoutSwitch.querySelectorAll('button[data-col]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.classList.contains('is--active')));
      });
    });
  };

  const homeCarouselScopes = [
    'body.template-index :is([id$="__featured_collection_cK9qda"], [id$="__bestSellers8L3mQx"])',
    'body.template-index [id$="__testimonials_QT36VG"]'
  ];
  const homeCarouselDotSelector = homeCarouselScopes
    .map((scope) => `${scope} ol.flickityt4s-page-dots > li.dot`)
    .join(', ');

  const syncHomeCarouselDots = (root = document) => {
    const dots = new Set(root.querySelectorAll?.(homeCarouselDotSelector) || []);
    if (root.matches?.(homeCarouselDotSelector)) dots.add(root);

    const parentDot = root.closest?.(homeCarouselDotSelector);
    if (parentDot) dots.add(parentDot);

    dots.forEach((dot) => {
      const dotsList = dot.parentElement;
      const slideNumber = Array.from(dotsList?.children || []).indexOf(dot) + 1;
      if (slideNumber < 1) return;

      dot.setAttribute('role', 'button');
      dot.setAttribute('tabindex', '0');
      dot.setAttribute('aria-label', `Ir a la diapositiva ${slideNumber}`);

      if (dot.classList.contains('is-selected')) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  };

  const homeCarouselSlideSelector = homeCarouselScopes
    .map((scope) => `${scope} .flickityt4s-slider > *`)
    .join(', ');
  const homeCarouselFocusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]'
  ].join(',');
  const carouselTabindexAttribute = 'data-evano-carousel-tabindex';

  const syncHomeCarouselFocus = () => {
    document.querySelectorAll(homeCarouselSlideSelector).forEach((slide) => {
      const isHidden = slide.getAttribute('aria-hidden') === 'true';

      slide.querySelectorAll(homeCarouselFocusableSelector).forEach((control) => {
        const storedTabindex = control.getAttribute(carouselTabindexAttribute);

        if (isHidden) {
          if (storedTabindex === null) {
            control.setAttribute(
              carouselTabindexAttribute,
              control.hasAttribute('tabindex') ? control.getAttribute('tabindex') : 'none'
            );
          }
          control.setAttribute('tabindex', '-1');
          return;
        }

        if (storedTabindex === null) return;
        if (storedTabindex === 'none') control.removeAttribute('tabindex');
        else control.setAttribute('tabindex', storedTabindex);
        control.removeAttribute(carouselTabindexAttribute);
      });
    });
  };

  const mobileCardSwatchSelector = [
    'body.template-index [id*="featured_collection"]',
    'body.template-collection .t4s-main-collection-page'
  ].map((scope) => `${scope} .t4s-products:not(.is--listview) .t4s-pr-style3 .evano-product-variants .t4s-pr-color__item:not(.is--colors-more)`).join(', ');

  const mobileCardMedia = window.matchMedia('(max-width: 767px)');
  const swatchOwnershipAttribute = 'data-evano-swatch-a11y';
  const editorialFeaturedScopeSelector =
    'body.template-index :is([id$="__featured_collection_cK9qda"], [id$="__bestSellers8L3mQx"])';
  const editorialFeaturedSwatchSelector =
    `${editorialFeaturedScopeSelector} .t4s-product-colors ` +
    '.t4s-pr-color__item:not(.is--colors-more)';
  const editorialSelectedClasses = [
    'is-swatch--selected',
    'is--selected',
    'is-selected'
  ];
  const editorialVariantsOverlayAttribute = 'data-evano-editorial-overlay';
  const editorialBoundSwatches = new WeakSet();
  const editorialHandledKeyboardEvents = new WeakSet();
  const editorialPendingSwatchSelections = new WeakMap();

  const setOwnedSwatchAttribute = (swatch, name, value) => {
    const owned = new Set((swatch.getAttribute(swatchOwnershipAttribute) || '').split(' ').filter(Boolean));
    if (!swatch.hasAttribute(name)) owned.add(name);
    if (!owned.has(name)) return;

    swatch.setAttribute(name, value);
    swatch.setAttribute(swatchOwnershipAttribute, Array.from(owned).join(' '));
  };

  const clearOwnedSwatchAttributes = (swatch) => {
    const owned = (swatch.getAttribute(swatchOwnershipAttribute) || '').split(' ').filter(Boolean);
    owned.forEach((name) => swatch.removeAttribute(name));
    swatch.removeAttribute(swatchOwnershipAttribute);
  };

  const ownedSwatchesWithin = (root = document) => {
    const selector = `[${swatchOwnershipAttribute}]`;
    const swatches = new Set(root.querySelectorAll?.(selector) || []);
    if (root.matches?.(selector)) swatches.add(root);
    return swatches;
  };

  const clearProductSwatches = (root = document) => {
    ownedSwatchesWithin(root).forEach(clearOwnedSwatchAttributes);
  };

  const clearStaleProductSwatches = (root = document) => {
    ownedSwatchesWithin(root).forEach((swatch) => {
      if (swatch.matches(editorialFeaturedSwatchSelector)) return;
      if (!mobileCardMedia.matches || !swatch.matches(mobileCardSwatchSelector)) {
        clearOwnedSwatchAttributes(swatch);
      }
    });
  };

  const syncProductSwatches = (root = document) => {
    clearStaleProductSwatches(root);
    if (!mobileCardMedia.matches) return;

    const swatches = new Set(root.querySelectorAll?.(mobileCardSwatchSelector) || []);
    if (root.matches?.(mobileCardSwatchSelector)) swatches.add(root);

    const parentSwatch = root.closest?.(mobileCardSwatchSelector);
    if (parentSwatch) swatches.add(parentSwatch);

    swatches.forEach((swatch) => {
      const name = swatch.querySelector('.t4s-pr-color__name')?.textContent.trim();
      if (!name) return;

      setOwnedSwatchAttribute(swatch, 'role', 'button');
      setOwnedSwatchAttribute(swatch, 'tabindex', '0');
      setOwnedSwatchAttribute(swatch, 'aria-label', name);
      const isSelected = swatch.classList.contains('is-swatch--selected') ||
        swatch.classList.contains('is--selected');
      setOwnedSwatchAttribute(swatch, 'aria-pressed', String(isSelected));
    });
  };

  const setAttributeIfChanged = (element, name, value) => {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  };

  const editorialSwatchLabel = (swatch, index, colors) => {
    const visibleName = swatch.querySelector('.t4s-pr-color__name')?.textContent.trim();
    if (visibleName) return visibleName;

    const existingLabel = swatch.getAttribute('aria-label')?.trim();
    if (existingLabel) return existingLabel;

    try {
      const options = JSON.parse(colors.getAttribute('data-color-options') || '{}');
      const optionName = options.color_variants?.[index];
      if (typeof optionName === 'string' && optionName.trim()) return optionName.trim();
    } catch (_error) {
      // A missing or malformed optional color payload must not block accessibility.
    }

    return `Color ${index + 1}`;
  };

  const hasEditorialSelectionState = (swatch) =>
    editorialSelectedClasses.some((className) => swatch.classList.contains(className));

  const editorialSwatchDescriptor = (swatch) => {
    if (!swatch) return null;

    for (const attribute of ['data-vid', 'data-imgid', 'data-img']) {
      const value = swatch.getAttribute(attribute)?.trim();
      if (value) return { attribute, value };
    }

    const label = swatch.getAttribute('aria-label')?.trim() ||
      swatch.querySelector('.t4s-pr-color__name')?.textContent.trim();
    return label ? { attribute: 'aria-label', value: label } : null;
  };

  const matchesEditorialSwatchDescriptor = (swatch, descriptor) => {
    if (!descriptor) return false;
    if (descriptor.attribute !== 'aria-label') {
      return swatch.getAttribute(descriptor.attribute)?.trim() === descriptor.value;
    }

    const label = swatch.getAttribute('aria-label')?.trim() ||
      swatch.querySelector('.t4s-pr-color__name')?.textContent.trim();
    return label === descriptor.value;
  };

  const restoreEditorialSwatchSelection = (variants, descriptor) => {
    if (!descriptor) return;

    const swatches = Array.from(
      variants.querySelectorAll('.t4s-pr-color__item:not(.is--colors-more)')
    );
    if (!swatches.length) {
      editorialPendingSwatchSelections.set(variants, descriptor);
      return;
    }

    const matchedSwatch = swatches.find((swatch) =>
      matchesEditorialSwatchDescriptor(swatch, descriptor)
    );
    const selectedSwatch = matchedSwatch || swatches[0];

    swatches.forEach((swatch) => {
      const isSelected = swatch === selectedSwatch;
      editorialSelectedClasses.forEach((className) => {
        if (swatch.classList.contains(className) !== (isSelected && className === 'is-swatch--selected')) {
          swatch.classList.toggle(className, isSelected && className === 'is-swatch--selected');
        }
      });
      setAttributeIfChanged(swatch, 'aria-pressed', String(isSelected));
    });

    editorialPendingSwatchSelections.delete(variants);
  };

  const syncEditorialSwatchGroup = (colors, preferredSwatch = null) => {
    const swatches = Array.from(
      colors.querySelectorAll('.t4s-pr-color__item:not(.is--colors-more)')
    ).filter((swatch) => swatch.matches(editorialFeaturedSwatchSelector));
    if (!swatches.length) return;

    const selectedByClass = swatches.find(hasEditorialSelectionState);
    const selectedByAria = swatches.find(
      (swatch) => swatch.getAttribute('aria-pressed') === 'true'
    );
    const selected = swatches.includes(preferredSwatch)
      ? preferredSwatch
      : selectedByClass || selectedByAria || swatches[0];

    swatches.forEach((swatch, index) => {
      const isSelected = swatch === selected;

      setAttributeIfChanged(swatch, 'role', 'button');
      setAttributeIfChanged(swatch, 'tabindex', '0');
      setAttributeIfChanged(
        swatch,
        'aria-label',
        editorialSwatchLabel(swatch, index, colors)
      );
      setAttributeIfChanged(swatch, 'aria-pressed', String(isSelected));

      if (swatch.classList.contains('is-swatch--selected') !== isSelected) {
        swatch.classList.toggle('is-swatch--selected', isSelected);
      }
    });

    // A colour cannot be communicated by a small dot alone. Keep the visible
    // selected state on the same utility rail as the swatches, so a customer
    // can confirm the image/variant they just chose.
    const variants = colors.closest('.evano-product-variants');
    if (variants && selected) {
      const selectedLabel = editorialSwatchLabel(
        selected,
        swatches.indexOf(selected),
        colors
      );
      variants.dataset.selectedColor = selectedLabel;
      let visibleLabel = variants.querySelector(':scope > .evano-color-swatch-label');
      if (!visibleLabel) {
        visibleLabel = document.createElement('span');
        visibleLabel.className = 'evano-color-swatch-label';
        variants.appendChild(visibleLabel);
      }
      // The theme observes character mutations across the storefront. Do not
      // rewrite an identical label, or that observer continually remounts the
      // carousel and can freeze a mobile browser.
      if (visibleLabel.textContent !== selectedLabel) {
        visibleLabel.textContent = selectedLabel;
      }

      const productInner = variants.closest('.t4s-product')?.querySelector('.t4s-product-inner');
      if (productInner) {
        let status = productInner.querySelector(':scope > .evano-mobile-variant-status');
        if (!status) {
          status = document.createElement('span');
          status.className = 'evano-mobile-variant-status';
          status.setAttribute('aria-live', 'polite');
          status.textContent = selectedLabel;
          productInner.appendChild(status);
        } else if (status.textContent !== selectedLabel) {
          status.textContent = selectedLabel;
        }
      }
    }
  };

  const syncEditorialFeaturedSwatches = (preferredSwatch = null) => {
    document.querySelectorAll(editorialFeaturedScopeSelector).forEach((scope) => {
      scope.querySelectorAll('.t4s-product-colors').forEach((colors) => {
        syncEditorialSwatchGroup(
          colors,
          colors.contains(preferredSwatch) ? preferredSwatch : null
        );
      });
    });
  };

  const syncEditorialFeaturedPrices = () => {
    document.querySelectorAll(editorialFeaturedScopeSelector).forEach((scope) => {
      scope.querySelectorAll('.evano-product-price .t4s-product-price').forEach((price) => {
        price.querySelectorAll('ins').forEach((salePrice) => {
          const priceRow = salePrice.parentElement;
          const comparePrice = Array.from(priceRow?.children || []).find(
            (child) => child.tagName === 'DEL'
          );

          const saleFollowsCompare = comparePrice && Boolean(
            comparePrice.compareDocumentPosition(salePrice) & Node.DOCUMENT_POSITION_FOLLOWING
          );

          if (priceRow && saleFollowsCompare) {
            priceRow.insertBefore(salePrice, comparePrice);
          }
        });
      });
    });
  };

  const moveEditorialFeaturedVariants = (product) => {
    const media = product.querySelector('.t4s-product-inner');
    if (!media) return false;

    const candidates = Array.from(
      product.querySelectorAll('.evano-product-variants')
    );
    if (!candidates.length) return false;

    const ownerCandidates = candidates.filter((variants) =>
      variants.closest('.t4s-product-info__inner')?.closest('.t4s-product') === product
    );
    const overlayCandidates = candidates.filter(
      (variants) => variants.parentElement === media
    );
    const canonical = ownerCandidates.at(-1) || overlayCandidates.at(-1) || candidates.at(-1);
    const staleSelectionDescriptor = editorialSwatchDescriptor(
      overlayCandidates
        .flatMap((variants) => Array.from(
          variants.querySelectorAll('.t4s-pr-color__item:not(.is--colors-more)')
        ))
        .find(hasEditorialSelectionState)
    );
    const selectionDescriptor = staleSelectionDescriptor ||
      editorialPendingSwatchSelections.get(canonical);

    candidates.forEach((variants) => {
      if (variants !== canonical) variants.remove();
    });

    setAttributeIfChanged(canonical, editorialVariantsOverlayAttribute, '');
    restoreEditorialSwatchSelection(canonical, selectionDescriptor);
    canonical.toggleAttribute(
      'hidden',
      !canonical.querySelector('.t4s-pr-color__item:not(.is--colors-more)')
    );

    if (canonical.parentElement === media) return false;

    media.appendChild(canonical);
    return true;
  };

  const reconcileEditorialFeaturedVariants = () => {
    document.querySelectorAll(editorialFeaturedScopeSelector).forEach((scope) => {
      let movedVariantNode = false;

      scope.querySelectorAll('.t4s-product').forEach((product) => {
        if (moveEditorialFeaturedVariants(product)) movedVariantNode = true;
      });

      const carousel = scope.querySelector('.t4s-products.flickityt4s-enabled');
      const flickity = window.jQuery_T4NT;
      const carouselInstance = carousel && flickity?.(carousel).data('flickityt4s');
      if (!movedVariantNode || !carouselInstance) return;

      requestAnimationFrame(() => {
        if (!carousel.isConnected) return;
        carouselInstance.resize();
      });
    });
  };

  const syncEditorialFeaturedCollection = (preferredSwatch = null) => {
    reconcileEditorialFeaturedVariants();
    syncEditorialFeaturedSwatches(preferredSwatch);
    syncEditorialFeaturedPrices();
    bindEditorialFeaturedSwatches();
  };
  let editorialSyncScheduled = false;
  const scheduleEditorialFeaturedCollection = () => {
    if (editorialSyncScheduled) return;
    editorialSyncScheduled = true;
    requestAnimationFrame(() => {
      editorialSyncScheduled = false;
      syncEditorialFeaturedCollection();
    });
  };

  const updateEditorialVariantLinks = (product, variantId) => {
    if (!variantId) return;

    product.querySelectorAll('[data-pr-href]').forEach((link) => {
      const href = link.getAttribute('href');
      if (!href) return;

      const nextHref = /([?&])variant=[^&]*/.test(href)
        ? href.replace(/([?&])variant=[^&]*/, `$1variant=${variantId}`)
        : `${href}${href.includes('?') ? '&' : '?'}variant=${variantId}`;
      setAttributeIfChanged(link, 'href', nextHref);
    });
  };

  const selectEditorialImageSlide = (product, swatch) => {
    const carousel = product.querySelector(
      '.flickityt4s-enabled[data-product-img-carousel]'
    );
    const imageId = swatch.getAttribute('data-imgid');
    const slide = carousel?.querySelector(`[data-product-img-slide="${imageId}"]`);
    const flickity = window.jQuery_T4NT;

    if (!carousel || !slide || typeof flickity?.fn?.flickityt4s !== 'function') {
      return false;
    }

    flickity(carousel).flickityt4s(
      'select',
      Array.from(carousel.querySelectorAll('[data-product-img-slide]')).indexOf(slide)
    );
    return true;
  };

  const activateEditorialSwatch = (swatch) => {
    const product = swatch.closest('[data-product-options]');
    const colors = swatch.closest('.t4s-product-colors');
    if (!product || !colors) return false;

    const imageId = swatch.getAttribute('data-imgid') || '0';
    const imageUrl = swatch.getAttribute('data-img');
    const variantId = swatch.getAttribute('data-vid');

    if (imageId === '0') {
      if (imageUrl && imageUrl !== 'none') {
        const source = imageUrl.split(',')[0].trim().split(' ')[0];
        product.querySelectorAll('[data-pr-img]').forEach((image) => {
          setAttributeIfChanged(image, 'data-srcset', imageUrl);
          setAttributeIfChanged(image, 'data-src', source);
          setAttributeIfChanged(image, 'srcset', imageUrl);
          setAttributeIfChanged(image, 'src', source);
        });
      }
    } else {
      selectEditorialImageSlide(product, swatch);
    }

    updateEditorialVariantLinks(product, variantId);
    syncEditorialSwatchGroup(colors, swatch);
    return true;
  };

  const themeHandlesTouchSwatchClick = () => window.T4SThemeSP?.isTouch === true;

  const bindEditorialFeaturedSwatches = () => {
    document.querySelectorAll(editorialFeaturedSwatchSelector).forEach((swatch) => {
      if (editorialBoundSwatches.has(swatch)) return;
      editorialBoundSwatches.add(swatch);

      swatch.addEventListener('click', () => {
        // Touch layouts already have the theme's delegated click activation.
        if (themeHandlesTouchSwatchClick()) return;
        if (activateEditorialSwatch(swatch)) syncEditorialFeaturedPrices();
      });

      swatch.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        editorialHandledKeyboardEvents.add(event);
        if (activateEditorialSwatch(swatch)) syncEditorialFeaturedPrices();
      });
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const loadMore = event.target.closest?.('[data-load-more]');
      if (loadMore) correctLoadMoreHref(loadMore);

      const layoutButton = event.target.closest?.('[data-layout-switch] button[data-col]');
      if (layoutButton) requestAnimationFrame(() => syncLayoutSwitchState(layoutButton.closest('[data-layout-switch]')));
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    const carouselDot = event.target.closest?.(homeCarouselDotSelector);
    if (carouselDot && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      carouselDot.click();
      requestAnimationFrame(() => syncHomeCarouselDots(carouselDot.parentElement));
      return;
    }

    if (editorialHandledKeyboardEvents.has(event)) return;

    if (!mobileCardMedia.matches) return;

    const swatch = event.target.closest?.(mobileCardSwatchSelector);
    if (!swatch || (event.key !== 'Enter' && event.key !== ' ')) return;

    event.preventDefault();
    // The theme binds hover on pointer-capable layouts and click on touch layouts.
    // Both paths select the same swatch, so invoking them in sequence is idempotent.
    swatch.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
    swatch.click();
    requestAnimationFrame(() => syncProductSwatches(swatch.closest('.evano-product-variants')));
  });

  labelIconControls();
  syncMenuDisclosureState();
  syncLoadMoreState();
  syncCartCountBadges();
  syncLayoutSwitchState();
  syncHomeCarouselDots();
  syncProductSwatches();
  syncHomeCarouselFocus();
  syncEditorialFeaturedCollection();
  document.addEventListener('shopify:section:load', () => {
    syncEditorialFeaturedCollection();
  });
  mobileCardMedia.addEventListener('change', (event) => {
    if (event.matches) syncProductSwatches();
    else clearProductSwatches();
    syncEditorialFeaturedCollection();
  });
  const storefrontStructureObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      syncCartCountBadges(mutation.target.nodeType === Node.ELEMENT_NODE
        ? mutation.target
        : mutation.target.parentElement);

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        labelIconControls(node);
        syncLoadMoreState(node);
        syncCartCountBadges(node);
        syncLayoutSwitchState(node);
        syncHomeCarouselDots(node);
        syncProductSwatches(node);
        if (node.matches?.(editorialFeaturedScopeSelector) ||
            node.closest?.(editorialFeaturedScopeSelector) ||
            node.querySelector?.(editorialFeaturedScopeSelector)) {
          scheduleEditorialFeaturedCollection();
        }
      });
    });
    syncHomeCarouselFocus();
  });
  storefrontStructureObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  const mobileMenuDrawer = document.querySelector('#t4s-menu-drawer');
  if (mobileMenuDrawer) {
    new MutationObserver(syncMenuDisclosureState).observe(mobileMenuDrawer, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  const editorialAttributeObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      syncHomeCarouselDots(mutation.target);
      syncProductSwatches(mutation.target);
    });
    syncHomeCarouselFocus();
    scheduleEditorialFeaturedCollection();
  });

  const observeEditorialAttributeRoots = () => {
    document.querySelectorAll(editorialFeaturedScopeSelector).forEach((root) => {
      if (root.dataset.evanoEditorialAttributesObserved === 'true') return;
      root.dataset.evanoEditorialAttributesObserved = 'true';
      editorialAttributeObserver.observe(root, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden'],
        subtree: true
      });
    });
  };

  observeEditorialAttributeRoots();
  document.addEventListener('shopify:section:load', observeEditorialAttributeRoots);

  window.addEventListener('popstate', () => queueMicrotask(syncLoadMoreState));
})();

/* EVANO — do not leave conversion-driving product media behind a 1px
   lazysizes placeholder. Native responsive loading remains lazy off screen. */
(() => {
  const collectionSelector = [
    'body.template-index [id$="__bestSellers8L3mQx"]',
    'body.template-index [id$="__featured_collection_cK9qda"]',
    'body.template-collection .t4s-main-collection-page'
  ].join(',');
  const cardSelector = collectionSelector
    .split(',')
    .map((selector) => `${selector} .t4s-product`)
    .join(',');
  const observedCards = new WeakSet();

  const imageUrl = (source, width) => {
    try {
      const url = new URL(source, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (_error) {
      return source;
    }
  };

  const imageWidths = (image) => {
    try {
      const widths = JSON.parse(image.getAttribute('data-widths') || '[]');
      return widths.filter((width) => Number.isFinite(width) && width > 0 && width <= 900);
    } catch (_error) {
      return [];
    }
  };

  const hydrateCardImage = (card, priority = false) => {
    const image = card?.querySelector('.t4s-product-main-img');
    const source = image?.getAttribute('data-src');
    if (!image || !source || image.dataset.evanoResponsiveHydrated === 'true') return;

    const widths = imageWidths(image);
    if (!widths.length) widths.push(330, 500, 700, 900);
    const renderedWidth = Math.max(280, Math.ceil(image.getBoundingClientRect().width || 0));
    const requestedWidth = Math.min(900, Math.ceil(renderedWidth * Math.min(window.devicePixelRatio || 1, 2)));
    const targetWidth = widths.find((width) => width >= requestedWidth) || widths[widths.length - 1];

    image.dataset.evanoResponsiveHydrated = 'true';
    image.srcset = widths.map((width) => `${imageUrl(source, width)} ${width}w`).join(', ');
    image.sizes = `${renderedWidth}px`;
    image.src = imageUrl(source, targetWidth);
    image.loading = priority ? 'eager' : 'lazy';
    if (priority) image.setAttribute('fetchpriority', 'high');
    image.classList.remove('lazyloadt4s');
    image.classList.add('lazyloadt4sed');
  };

  const imageObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          hydrateCardImage(entry.target);
          imageObserver.unobserve(entry.target);
        });
      }, { rootMargin: '700px 160px' })
    : null;

  const initializeImages = (root = document) => {
    const cards = new Set(root.querySelectorAll?.(cardSelector) || []);
    if (root.matches?.(cardSelector)) cards.add(root);

    cards.forEach((card) => {
      if (observedCards.has(card)) return;
      observedCards.add(card);

      const section = card.closest(collectionSelector);
      const isPriorityCollection = Boolean(
        section?.id.endsWith('__bestSellers8L3mQx') ||
        section?.matches('.t4s-main-collection-page')
      );
      const sectionCards = isPriorityCollection
        ? Array.from(section.querySelectorAll('.t4s-product'))
        : [];
      const cardIndex = sectionCards.indexOf(card);
      const preparedCardCount = window.innerWidth >= 768 ? 4 : 2;
      const isLeadCard = cardIndex >= 0 && cardIndex < preparedCardCount;

      if (isLeadCard || !imageObserver) hydrateCardImage(card, cardIndex === 0);
      else imageObserver.observe(card);
    });
  };

  initializeImages();
  document.addEventListener('shopify:section:load', (event) => initializeImages(event.target));
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initializeImages(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

(() => {
  const scopes = [
    'body.template-index :is([id$="__featured_collection_cK9qda"], [id$="__bestSellers8L3mQx"])',
    'body.template-collection .t4s-main-collection-page'
  ];
  const swatchSelector = scopes.map((selector) =>
    selector + ' .t4s-pr-color__item[data-vid]'
  ).join(', ');
  const selectedSwatchSelector = scopes.flatMap((selector) => [
    selector + ' .t4s-pr-color__item[data-vid].is-swatch--selected',
    selector + ' .t4s-pr-color__item[data-vid][aria-pressed="true"]'
  ]).join(', ');
  const quickshopSelector = scopes.map((selector) =>
    selector + ' a[data-action-quickshop]'
  ).join(', ');
  const swatchImageCache = new Map();

  const responsiveImageUrl = (source, width) => {
    if (!source) return '';
    const cleanSource = String(source).split(',')[0].trim().split(' ')[0];
    try {
      const url = new URL(cleanSource, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (_error) {
      return cleanSource.replace('width=1', 'width=' + width);
    }
  };

  const cardImageWidths = (card) => {
    const image = card?.querySelector('.t4s-product-main-img');
    const renderedWidth = Math.max(160, Math.ceil(image?.getBoundingClientRect().width || 0));
    const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
    const requestedWidth = Math.min(900, Math.ceil(renderedWidth * pixelRatio));
    const widths = [240, 330, 400, 500, 600, 700, 800, 900];
    const targetWidth = widths.find((width) => width >= requestedWidth) || 900;
    return { renderedWidth, targetWidth, widths: widths.filter((width) => width <= Math.max(500, targetWidth)) };
  };

  const preloadCardSwatch = (swatch) => {
    const card = swatch?.closest('.t4s-product');
    const source = swatch?.dataset.img;
    if (!card || !source || source === 'none') return Promise.resolve('');

    const { targetWidth } = cardImageWidths(card);
    const url = responsiveImageUrl(source, targetWidth);
    if (swatchImageCache.has(url)) return swatchImageCache.get(url);

    const request = new Promise((resolve) => {
      const preview = new Image();
      preview.decoding = 'async';
      preview.onload = () => resolve(url);
      preview.onerror = () => resolve(url);
      preview.src = url;
      if (preview.complete) resolve(url);
    });
    swatchImageCache.set(url, request);
    return request;
  };

  const cardSelector = scopes.map((selector) =>
    selector + ' .t4s-product'
  ).join(', ');
  const swatchPreloadLimit = navigator.connection?.saveData ? 1 : 2;
  const preloadCardSwatches = (card) => {
    const swatches = Array.from(
      card.querySelectorAll('.t4s-pr-color__item[data-vid][data-img]')
    );
    const prioritySwatches = swatches.slice(0, swatchPreloadLimit);
    prioritySwatches.forEach(preloadCardSwatch);

    if (navigator.connection?.saveData || swatches.length <= swatchPreloadLimit) return;
    Promise.allSettled(prioritySwatches.map(preloadCardSwatch)).then(() => {
      const preloadRemaining = () => {
        swatches.slice(swatchPreloadLimit).forEach(preloadCardSwatch);
      };
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(preloadRemaining, { timeout: 1800 });
      } else {
        window.setTimeout(preloadRemaining, 900);
      }
    });
  };
  const cardSwatchObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          preloadCardSwatches(entry.target);
          cardSwatchObserver.unobserve(entry.target);
        });
      }, { rootMargin: '20px 40px' })
    : null;
  const observeCardSwatches = (root = document) => {
    const cards = new Set(root.querySelectorAll?.(cardSelector) || []);
    if (root.matches?.(cardSelector)) cards.add(root);
    cards.forEach((card) => {
      if (card.dataset.evanoSwatchPreloadObserved === 'true') return;
      card.dataset.evanoSwatchPreloadObserved = 'true';
      if (cardSwatchObserver) cardSwatchObserver.observe(card);
      else preloadCardSwatches(card);
    });
  };

  observeCardSwatches();
  document.addEventListener('shopify:section:load', (event) => observeCardSwatches(event.target));

  const syncQuickshopVariant = (swatch) => {
    const card = swatch && swatch.closest('.t4s-product');
    const variantId = swatch && swatch.dataset.vid;
    if (!card || !variantId) return;

    card.dataset.evanoSelectedVariant = variantId;
    card.querySelectorAll('a[data-action-quickshop]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      url.searchParams.set('variant', variantId);
      link.setAttribute('href', url.pathname + url.search);
      link.dataset.variantId = variantId;
    });
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (swatch) queueMicrotask(() => syncQuickshopVariant(swatch));
  });

  document.addEventListener('click', (event) => {
    const quickshop = event.target.closest(quickshopSelector);
    if (!quickshop) return;
    const card = quickshop.closest('.t4s-product');
    const selected = card && card.querySelector('.t4s-pr-color__item.is-swatch--selected[data-vid], .t4s-pr-color__item[aria-pressed="true"][data-vid]');
    syncQuickshopVariant(selected);
  }, true);

  document.querySelectorAll(selectedSwatchSelector).forEach(syncQuickshopVariant);
  document.addEventListener('keydown', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch || (event.key !== 'Enter' && event.key !== ' ')) return;
    queueMicrotask(() => syncQuickshopVariant(swatch));
  });

  
  const applyQuickSwatch = (swatch) => {
    const card = swatch.closest('.t4s-product');
    if (!card) return;
    const variants = card.querySelector('.evano-product-variants');
    if (variants) variants.dataset.selectedColor = swatch.getAttribute('aria-label') || '';
    card.querySelectorAll('.t4s-pr-color__item[data-vid]').forEach((item) => {
      const selected = item === swatch;
      item.classList.toggle('is-swatch--selected', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
    const image = card.querySelector('.t4s-product-main-img');
    const imageUrl = swatch.dataset.img;
    if (image && imageUrl) {
      const revision = String((Number(card.dataset.evanoSwatchRevision) || 0) + 1);
      const { renderedWidth, targetWidth, widths } = cardImageWidths(card);
      const source = responsiveImageUrl(imageUrl, targetWidth);
      const srcset = widths.map((width) =>
        responsiveImageUrl(imageUrl, width) + ' ' + width + 'w'
      ).join(', ');
      card.dataset.evanoSwatchRevision = revision;

      preloadCardSwatch(swatch).then(() => {
        if (!card.isConnected || card.dataset.evanoSwatchRevision !== revision) return;

        [image, card.querySelector('.t4s-product-hover-img')].filter(Boolean).forEach((target) => {
          target.setAttribute('data-src', source);
          target.setAttribute('data-srcset', srcset);
          target.src = source;
          target.srcset = srcset;
          target.sizes = renderedWidth + 'px';
          target.loading = 'eager';
          target.decoding = 'async';
          target.classList.remove('lazyloadt4s');
          target.classList.add('lazyloadt4sed');
        });
      });
    }
    syncQuickshopVariant(swatch);
  };

  document.querySelectorAll(selectedSwatchSelector).forEach((swatch) => {
    const variants = swatch.closest('.t4s-product')?.querySelector('.evano-product-variants');
    if (variants) variants.dataset.selectedColor = swatch.getAttribute('aria-label') || '';
  });


  document.addEventListener('click', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    applyQuickSwatch(swatch);
  }, true);

  ['pointerover', 'focusin', 'touchstart', 'pointerdown'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      preloadCardSwatch(event.target.closest?.(swatchSelector));
    }, { capture: true, passive: true });
  });

  document.addEventListener('keydown', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    applyQuickSwatch(swatch);
  }, true);




})();

/* Evano: ensure the CTA copy is also applied after Shopify injects the section. */
(function () {
  function applyJeanGuideCta() {
    document.querySelectorAll('[id$="__banner_3wwTt3"] .t4s-banner-content .t4s-btn').forEach(function (button) {
      var href = button.getAttribute('href') || '';
      var visibleLabel = 'VER JEANS';
      var accessibleLabel = 'Ver jeans';
      if (href.indexOf('ideales-para-dias-calidos') !== -1) {
        visibleLabel = 'VER BERMUDAS';
        accessibleLabel = 'Ver bermudas';
      } else if (href.indexOf('complementa-tu-look') !== -1) {
        visibleLabel = 'VER CHAQUETAS';
        accessibleLabel = 'Ver chaquetas';
      }
      if (button.textContent.trim() !== visibleLabel) {
        button.textContent = visibleLabel;
      }
      button.setAttribute('aria-label', accessibleLabel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyJeanGuideCta, { once: true });
  } else {
    applyJeanGuideCta();
  }
  document.addEventListener('shopify:section:load', applyJeanGuideCta);
  window.addEventListener('load', applyJeanGuideCta, { once: true });
}());


/* Evano: remove the residual doubled bottom gap on mobile. */
(function () {
  function compactJeanGuideGap() {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    var section = document.querySelector('[id$="__top_heading_3WRr3j"]');
    var inner = section && section.querySelector('.t4s-section-inner');
    if (section) section.style.setProperty('margin', '8px 0 0', 'important');
    if (inner) inner.style.setProperty('margin', '8px 0 4px', 'important');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', compactJeanGuideGap, { once: true });
  } else {
    compactJeanGuideGap();
  }
  document.addEventListener('shopify:section:load', compactJeanGuideGap);
  window.addEventListener('resize', compactJeanGuideGap, { passive: true });
}());


/* Evano: prevent Shopify effects from reintroducing motion in the jean guide. */
(function () {
  function lockJeanGuideMotion() {
    var section = document.querySelector('[id$="__banner_3wwTt3"]');
    if (!section) return;
    section.querySelectorAll('.t4s-isotopet4s-item, .t4s-banner-item, .t4s-banner-inner, .t4s-img-as-bg, .t4s-banner-content, .t4s-animate-init').forEach(function (element) {
      element.style.setProperty('animation', 'none', 'important');
      element.style.setProperty('transition', 'none', 'important');
      element.style.setProperty('transform', 'none', 'important');
      element.style.setProperty('will-change', 'auto', 'important');
    });
    section.querySelectorAll('.t4s-animate-init').forEach(function (element) {
      element.style.setProperty('opacity', '1', 'important');
      element.style.setProperty('visibility', 'visible', 'important');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lockJeanGuideMotion, { once: true });
  } else {
    lockJeanGuideMotion();
  }
  document.addEventListener('shopify:section:load', lockJeanGuideMotion);
  window.addEventListener('load', lockJeanGuideMotion, { once: true });
}());


/* Evano: merge the two contextual denim routes into the primary jean guide. */
(function () {
  function loadMergedImages(section) {
    var desktop = window.matchMedia('(min-width: 768px)').matches;
    section.querySelectorAll('.evano-jean-guide-extra img[data-src]').forEach(function (image) {
      var shouldLoad = desktop ? image.classList.contains('t4s-d-md-block') : image.classList.contains('t4s-d-md-none');
      if (!shouldLoad || image.src.indexOf('data:image/gif') !== 0) return;
      var width = desktop ? '1200' : '750';
      image.src = image.getAttribute('data-src').replace('width=1', 'width=' + width);
    });
  }

  function mergeJeanGuideCards() {
    var primarySection = document.querySelector('[id$="__banner_3wwTt3"]');
    var sourceSection = document.querySelector('[id$="__banner_nykqkR"]');
    var primaryHolder = primarySection && primarySection.querySelector('.t4s-banner-holder');
    var sourceHolder = sourceSection && sourceSection.querySelector('.t4s-banner-holder');
    if (!primaryHolder || !sourceHolder) return;

    if (primaryHolder.dataset.evanoFiveRoutes !== 'true') {
      Array.prototype.slice.call(sourceHolder.querySelectorAll('.t4s-isotopet4s-item')).forEach(function (card) {
        card.classList.remove('t4s-col-lg-6', 't4s-col-md-6');
        card.classList.add('evano-jean-guide-extra');
        card.removeAttribute('style');
        card.querySelectorAll('.t4s-banner-item, .t4s-banner-inner, .t4s-img-as-bg, .t4s-banner-content, .t4s-animate-init').forEach(function (element) {
          element.style.setProperty('animation', 'none', 'important');
          element.style.setProperty('transition', 'none', 'important');
          element.style.setProperty('transform', 'none', 'important');
          element.style.setProperty('will-change', 'auto', 'important');
        });
        primaryHolder.appendChild(card);
      });
      primaryHolder.dataset.evanoFiveRoutes = 'true';
      primaryHolder.style.setProperty('height', 'auto', 'important');
    }

    sourceSection.style.setProperty('display', 'none', 'important');
    loadMergedImages(primarySection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mergeJeanGuideCards, { once: true });
  } else {
    mergeJeanGuideCards();
  }
  document.addEventListener('shopify:section:load', mergeJeanGuideCards);
  window.addEventListener('load', mergeJeanGuideCards, { once: true });
  window.addEventListener('resize', mergeJeanGuideCards, { passive: true });
}());

(function () {
  var shippingSelector = '[id$="__shipping_UpeF7C"], .shopify-section.t4s-shipping';
  var adviceHref = 'https://wa.me/573134746015?text=' +
    encodeURIComponent('Hola, necesito asesoría para elegir mi jean ideal en EVANO.');

  function ensureAdvice() {
    var shipping = document.querySelector(shippingSelector);
    if (!shipping) return;
    var row = document.querySelector('.evano-badges-advice');

    if (!row) {
      row = document.createElement('div');
      row.className = 'evano-badges-advice';
      row.setAttribute('data-evano-advice', 'whatsapp');
      row.innerHTML = '<a class="evano-badges-advice__link" target="_blank" rel="noopener"></a>';
      shipping.insertAdjacentElement('afterend', row);
    }

    var link = row.querySelector('a');
    link.href = adviceHref;
    link.textContent = 'Asesoría por WhatsApp';
    link.setAttribute('aria-label', 'Recibir asesoría por WhatsApp para elegir tu jean');
  }

  ensureAdvice();
  document.addEventListener('DOMContentLoaded', ensureAdvice, { once: true });
  document.addEventListener('shopify:section:load', ensureAdvice);
  window.addEventListener('load', ensureAdvice, { once: true });
})();

(function () {
  var root = document.documentElement;
  var initialStarted = false;
  var timeReady = false;
  var depthReady = false;
  var engaged = false;
  var recoveryScheduled = false;
  var windowTimer = 0;

  function nativeTeaser() {
    return document.querySelector('[data-testid="form-teaser"], button[aria-label="10% OFF"]');
  }

  function nativeTeaserVisible() {
    var teaser = nativeTeaser();
    if (!teaser) return false;
    var rect = teaser.getBoundingClientRect();
    var style = window.getComputedStyle(teaser);
    return rect.width > 0 && rect.height > 0 &&
      style.display !== 'none' && style.visibility !== 'hidden';
  }

  function removeFallback() {
    document.getElementById('evano-discount-teaser')?.remove();
    document.getElementById('evano-discount-modal')?.remove();
  }

  function buildFallback() {
    var native = nativeTeaser();
    if (native) {
      native.closest('#app-embed')?.setAttribute('data-evano-floating-teaser', 'true');
      return;
    }
    if (document.getElementById('evano-discount-teaser')) return;

    var teaser = document.createElement('button');
    teaser.id = 'evano-discount-teaser';
    teaser.className = 'ev-discount-teaser';
    teaser.type = 'button';
    teaser.textContent = '10% OFF';
    teaser.setAttribute('aria-haspopup', 'dialog');
    teaser.setAttribute('aria-controls', 'evano-discount-modal');
    teaser.setAttribute('aria-expanded', 'false');

    var modal = document.createElement('div');
    modal.id = 'evano-discount-modal';
    modal.className = 'ev-discount-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'evano-discount-title');
    modal.innerHTML =
      '<div class="ev-discount-modal__panel">' +
        '<button class="ev-discount-modal__close" type="button" aria-label="Cerrar popup de descuento">&times;</button>' +
        '<h2 class="ev-discount-modal__title" id="evano-discount-title">Obtén 10% OFF</h2>' +
        '<p class="ev-discount-modal__copy">Suscríbete y recibe el beneficio de bienvenida en tu correo.</p>' +
        '<form class="ev-discount-modal__form" method="post" action="/contact#evano-discount-modal">' +
          '<input type="hidden" name="form_type" value="customer">' +
          '<input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="contact[tags]" value="newsletter">' +
          '<label class="visually-hidden" for="evano-discount-email">Correo electrónico</label>' +
          '<input class="ev-discount-modal__email" id="evano-discount-email" type="email" name="contact[email]" placeholder="Tu correo electrónico" autocomplete="email" required>' +
          '<button class="ev-discount-modal__submit" type="submit">OBTENER DESCUENTO</button>' +
        '</form>' +
      '</div>';

    function closeModal() {
      modal.hidden = true;
      teaser.setAttribute('aria-expanded', 'false');
      document.documentElement.style.removeProperty('overflow');
      teaser.focus();
    }

    teaser.addEventListener('click', function () {
      modal.hidden = false;
      teaser.setAttribute('aria-expanded', 'true');
      document.documentElement.style.setProperty('overflow', 'hidden');
      window.setTimeout(function () {
        modal.querySelector('.ev-discount-modal__email')?.focus();
      }, 0);
    });
    modal.querySelector('.ev-discount-modal__close').addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    document.body.appendChild(teaser);
    document.body.appendChild(modal);
  }

  function closeWindow() {
    root.classList.add('ev-discount-window-closed');
    window.clearTimeout(windowTimer);
  }

  function blocked() {
    return document.hidden ||
      root.classList.contains('ev-floating-controls-hidden') ||
      root.classList.contains('ev-footer-in-view');
  }

  function openWindow(isRecovery) {
    if (engaged) return;
    if (blocked()) {
      if (isRecovery) window.setTimeout(function () { openWindow(true); }, 5000);
      return;
    }

    buildFallback();
    root.classList.remove('ev-discount-window-closed');

    windowTimer = window.setTimeout(function () {
      closeWindow();
      if (!isRecovery && !engaged && !recoveryScheduled) {
        recoveryScheduled = true;
        window.setTimeout(function () { openWindow(true); }, 45000);
      }
    }, 8000);
  }

  function tryInitial() {
    if (initialStarted || engaged || !(timeReady && depthReady)) return;
    initialStarted = true;
    openWindow(false);
  }

  function updateDepth() {
    var range = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    depthReady = window.scrollY / range >= 0.18;
    if (depthReady) window.removeEventListener('scroll', updateDepth);
    tryInitial();
  }

  closeWindow();
  window.setTimeout(buildFallback, 2500);
  window.setTimeout(function () {
    timeReady = true;
    updateDepth();
  }, 10000);
  window.setTimeout(function () {
    if (!initialStarted && !engaged) {
      depthReady = true;
      window.removeEventListener('scroll', updateDepth);
      tryInitial();
    }
  }, 25000);

  window.addEventListener('scroll', updateDepth, { passive: true });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) updateDepth();
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest &&
      event.target.closest('#evano-discount-teaser, [data-testid="form-teaser"], button[aria-label="10% OFF"]');
    if (!trigger) return;
    engaged = true;
    closeWindow();
  }, true);

  var nativeCheckScheduled = false;
  function syncNativeTeaser() {
    nativeCheckScheduled = false;
    if (nativeTeaserVisible()) {
      removeFallback();
      nativeTeaser().closest('#app-embed')?.setAttribute('data-evano-floating-teaser', 'true');
    } else if (!nativeTeaser()) {
      buildFallback();
    }
  }

  function scheduleNativeTeaserSync() {
    if (nativeCheckScheduled) return;
    nativeCheckScheduled = true;
    window.requestAnimationFrame(syncNativeTeaser);
  }

  var nativeWatcher = new MutationObserver(scheduleNativeTeaserSync);
  nativeWatcher.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(function () {
    scheduleNativeTeaserSync();
    nativeWatcher.disconnect();
  }, 30000);
})();

(function () {
  var scheduled = false;
  var productGridInView = false;
  var layerSelector = [
    '#t4s-menu-drawer',
    '#t4s-mini_cart',
    '#t4s-search-hidden',
    '#t4s-login-sidebar',
    '.t4s-modal',
    '.t4s-popup',
    '[role="dialog"]'
  ].join(',');

  function isVisibleLayer(element) {
    if (!element || element.id === 'evano-discount-teaser') return false;
    if (element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 &&
      rect.right > 0 && rect.left < window.innerWidth &&
      rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function refineGuideTitles() {
    document.querySelectorAll('[id$="__banner_3wwTt3"] .t4s-banner-content').forEach(function (content) {
      var button = content.querySelector('.t4s-btn');
      var title = content.querySelector('p.t4s-text-bl');
      if (!button || !title) return;
      var href = button.getAttribute('href') || '';
      if (href.indexOf('ideales-para-dias-calidos') !== -1) title.textContent = 'FRESCAS PARA DÍAS CÁLIDOS';
      if (href.indexOf('complementa-tu-look') !== -1) title.textContent = 'COMPLETAN TU LOOK';
    });
  }

  function syncUi() {
    scheduled = false;
    refineGuideTitles();
    var rootClass = document.documentElement.classList;
    var layerOpen = rootClass.contains('t4s-modal-opened') ||
      rootClass.contains('t4s-opening-qs') ||
      document.body.classList.contains('is--opend-drawer') ||
      Array.from(document.querySelectorAll(layerSelector)).some(isVisibleLayer);
    rootClass.toggle('ev-floating-controls-hidden', layerOpen || productGridInView);
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(syncUi);
  }

  function scheduleAfterInteraction() {
    scheduleSync();
    window.setTimeout(scheduleSync, 700);
  }

  function nodeTouchesLayer(node) {
    if (!node || node.nodeType !== 1) return false;
    return node.matches(layerSelector) ||
      Boolean(node.closest(layerSelector)) ||
      Boolean(node.querySelector(layerSelector));
  }

  function mutationsTouchLayers(mutations) {
    return mutations.some(function (mutation) {
      if (mutation.type === 'attributes') {
        return mutation.target === document.body || nodeTouchesLayer(mutation.target);
      }
      if (nodeTouchesLayer(mutation.target)) return true;
      return Array.from(mutation.addedNodes).some(nodeTouchesLayer) ||
        Array.from(mutation.removedNodes).some(nodeTouchesLayer);
    });
  }

  syncUi();
  new MutationObserver(function (mutations) {
    if (mutationsTouchLayers(mutations)) scheduleSync();
  }).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'open']
  });
  new MutationObserver(scheduleSync).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class']
  });

  var footer = document.querySelector('#t4s-footer, footer');
  if (footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      document.documentElement.classList.toggle('ev-footer-in-view', entries[0].isIntersecting);
    }, { threshold: 0.08 }).observe(footer);
  }

  var commerceSurface = document.querySelector([
    'body.template-collection .t4s-main-collection-page .t4s-products',
    'body.template-product .t4s-product__info-container'
  ].join(','));
  if (commerceSurface && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      productGridInView = entries[0].isIntersecting;
      scheduleSync();
    }, { threshold: 0.01 }).observe(commerceSurface);
  }

  document.addEventListener('click', scheduleAfterInteraction, true);
  document.addEventListener('keydown', scheduleAfterInteraction, true);
  document.addEventListener('shopify:section:load', scheduleSync);
  window.addEventListener('resize', scheduleSync, { passive: true });
})();

/* EVANO — expose price-changing finishes as visual variant swatches. */
(function () {
  var scope = 'body.template-index :is([id$="__featured_collection_cK9qda"], [id$="__bestSellers8L3mQx"])';
  var productCache = new Map();
  var scheduled = false;

  function optionName(option) {
    return typeof option === 'string' ? option : option && option.name || '';
  }

  function priceLabel(cents) {
    return '$' + new Intl.NumberFormat('es-CO').format(Math.round(Number(cents || 0) / 100)) + ' COP';
  }

  function imageSource(image, width) {
    if (!image) return '';
    var source = typeof image === 'string' ? image : image.src || '';
    if (!source) return '';
    try {
      var url = new URL(source, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (error) {
      return source;
    }
  }

  function setCardImage(card, source) {
    if (!source) return;
    var widths = [100, 200, 330, 400, 500, 600, 700, 800, 900];
    var srcset = widths.map(function (width) {
      return imageSource(source, width) + ' ' + width + 'w';
    }).join(', ');
    card.querySelectorAll('.t4s-product-main-img, .t4s-product-hover-img').forEach(function (image) {
      image.src = imageSource(source, 900);
      image.srcset = srcset;
      image.setAttribute('data-src', imageSource(source, 900));
      image.setAttribute('data-srcset', srcset);
    });
  }

  function cardImageSource(image) {
    if (!image) return '';
    var direct = image.getAttribute('data-src');
    if (direct) return direct;
    var responsive = image.getAttribute('data-srcset') || image.getAttribute('srcset') || '';
    if (responsive) return responsive.split(',')[0].trim().split(' ')[0];
    var source = image.currentSrc || image.src || '';
    return source.indexOf('data:image/gif') === 0 ? '' : source;
  }

  function updateQuickAdd(card, variantId) {
    if (!variantId) return;
    card.dataset.evanoSelectedVariant = String(variantId);
    card.querySelectorAll('a[data-action-quickshop], a[data-pr-href]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      if (!href) return;
      var url = new URL(href, window.location.origin);
      url.searchParams.set('variant', String(variantId));
      link.setAttribute('href', url.pathname + url.search);
      link.dataset.variantId = String(variantId);
    });
  }

  function updateVariantStatus(card, label) {
    var productInner = card && card.querySelector('.t4s-product-inner');
    if (!productInner) return;
    var status = productInner.querySelector(':scope > .evano-mobile-variant-status');
    if (!status) {
      status = document.createElement('span');
      status.className = 'evano-mobile-variant-status';
      status.setAttribute('aria-live', 'polite');
      status.textContent = label;
      productInner.appendChild(status);
    } else if (status.textContent !== label) {
      status.textContent = label;
    }
  }

  function selectCardChoice(card, choice) {
    card.querySelectorAll('.evano-option-swatch').forEach(function (button) {
      var selected = button.dataset.variantId === String(choice.variant.id);
      button.classList.toggle('is-swatch--selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    var slot = card.querySelector('.evano-product-variants[data-evano-finish-swatches]');
    if (slot) slot.dataset.selectedColor = choice.label;
    var choiceLabel = card.querySelector('.evano-option-swatch-label');
    if (choiceLabel) choiceLabel.textContent = choice.label;
    var price = card.querySelector('.t4s-product-price');
    if (price) price.textContent = priceLabel(choice.variant.price);
    updateVariantStatus(card, choice.label);
    setCardImage(card, choice.image);
    updateQuickAdd(card, choice.variant.id);
  }

  function buildFinishSwatches(card, product) {
    if (!card || card.dataset.evanoFinishSwatches === 'ready') return;
    var optionIndex = (product.options || []).findIndex(function (option) {
      return /estilo\s+de\s+desgaste|acabado|detalle/i.test(optionName(option));
    });
    if (optionIndex < 0) return;

    var values = new Map();
    var productVariants = Array.isArray(product.variants) ? product.variants : [];
    productVariants.forEach(function (variant) {
      var value = variant['option' + (optionIndex + 1)];
      if (value && !values.has(value)) values.set(value, variant);
    });
    var choices = Array.from(values.entries()).map(function (entry, index) {
      var label = entry[0] === 'Ninguno' ? 'Sin taches' : entry[0];
      var cardImages = Array.from(card.querySelectorAll('.t4s-product-main-img, .t4s-product-hover-img'));
      var fallback = cardImageSource(cardImages[index]);
      return {
        label: label,
        variant: entry[1],
        // The card already carries the two curated product images in the exact
        // visual order used by the product. Prefer them over stale variant media
        // returned by Shopify's JSON cache.
        image: fallback || entry[1].featured_image && entry[1].featured_image.src || product.images && product.images[index]
      };
    }).filter(function (choice) { return choice.image; });

    if (choices.length < 2) return;
    var slot = card.querySelector('.evano-product-variants');
    if (!slot) return;
    slot.removeAttribute('hidden');
    slot.dataset.evanoFinishSwatches = '';
    slot.dataset.selectedColor = choices[0].label;
    slot.replaceChildren();
    var group = document.createElement('div');
    group.className = 'evano-option-swatches';
    group.setAttribute('role', 'group');
    group.setAttribute('aria-label', optionName(product.options[optionIndex]));

    choices.forEach(function (choice, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'evano-option-swatch';
      button.dataset.variantId = String(choice.variant.id);
      button.dataset.evanoChoiceLabel = choice.label;
      button.dataset.evanoChoicePrice = String(choice.variant.price || 0);
      button.dataset.evanoChoiceImage = imageSource(choice.image, 900);
      button.setAttribute('aria-label', choice.label + ', ' + priceLabel(choice.variant.price));
      button.setAttribute('aria-pressed', String(index === 0));
      var image = document.createElement('img');
      image.src = imageSource(choice.image, 120);
      image.alt = '';
      image.width = 120;
      image.height = 120;
      button.appendChild(image);
      group.appendChild(button);
    });
    var label = document.createElement('span');
    label.className = 'evano-option-swatch-label';
    label.textContent = choices[0].label;
    group.appendChild(label);
    slot.appendChild(group);
    card.dataset.evanoFinishSwatches = 'ready';
    selectCardChoice(card, choices[0]);
  }

  function enhanceCard(card) {
    if (!card || card.dataset.evanoFinishSwatches === 'ready') return;
    var raw = card.dataset.productOptions;
    if (!raw) return;
    var productInfo;
    try { productInfo = JSON.parse(raw); } catch (error) { return; }
    if (!productInfo.handle) return;
    var request = productCache.get(productInfo.handle);
    if (!request) {
      request = fetch('/products/' + encodeURIComponent(productInfo.handle) + '.js').then(function (response) {
        return response.ok ? response.json() : null;
      }).catch(function () { return null; });
      productCache.set(productInfo.handle, request);
    }
    request.then(function (product) { if (product) buildFinishSwatches(card, product); });
  }

  function syncFinishSwatches() {
    scheduled = false;
    document.querySelectorAll(scope + ' .t4s-product[data-product-options]').forEach(enhanceCard);
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(syncFinishSwatches);
  }

  // Flickity can clone product cards. Delegation keeps cloned swatches
  // interactive because cloneNode does not preserve direct event listeners.
  function handleFinishSwatchSelection(event) {
    var button = event.target.closest(scope + ' .evano-option-swatch');
    if (!button) return;
    var card = button.closest('.t4s-product');
    var variantId = button.dataset.variantId;
    if (!card || !variantId) return;
    selectCardChoice(card, {
      label: button.dataset.evanoChoiceLabel || button.getAttribute('aria-label').split(',')[0],
      variant: {
        id: variantId,
        price: Number(button.dataset.evanoChoicePrice || 0)
      },
      image: button.dataset.evanoChoiceImage || button.querySelector('img') && button.querySelector('img').src
    });
  }
  document.addEventListener('click', handleFinishSwatchSelection, true);

  var finishContentObserver = new MutationObserver(scheduleSync);
  var finishVisibilityObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var slot = mutation.target;
      if (slot.matches && slot.matches('.evano-product-variants[data-evano-finish-swatches][hidden]')) {
        slot.removeAttribute('hidden');
      }
    });
  });

  function observeFinishRoots() {
    document.querySelectorAll(scope).forEach(function (root) {
      if (root.dataset.evanoFinishObserved === 'true') return;
      root.dataset.evanoFinishObserved = 'true';
      finishContentObserver.observe(root, { childList: true, subtree: true });
      finishVisibilityObserver.observe(root, {
        attributes: true,
        attributeFilter: ['hidden'],
        subtree: true
      });
    });
  }

  observeFinishRoots();
  syncFinishSwatches();
  document.addEventListener('shopify:section:load', function () {
    observeFinishRoots();
    scheduleSync();
  });
})();

/* EVANO — one deterministic source of truth for card → Quick Shop state. */
(function () {
  var scopes = [
    'body.template-index :is([id$="__featured_collection_cK9qda"], [id$="__bestSellers8L3mQx"])',
    'body.template-collection .t4s-main-collection-page'
  ];
  var quickshopLinkSelector = scopes.map(function (scope) {
    return scope + ' a[data-action-quickshop]';
  }).join(', ');
  var pendingIntent = null;
  var scheduled = false;
  var resolvingChoice = false;
  var choiceRevision = 0;
  var productCache = new Map();
  var warmedQuickshopLinks = new WeakSet();
  var productWarmQueue = [];
  var activeProductWarms = 0;
  var maxConcurrentProductWarms = 2;
  var quickshopPreloadObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          warmQuickshopLink(entry.target);
          quickshopPreloadObserver.unobserve(entry.target);
        });
      }, { rootMargin: '600px 0px' })
    : null;

  function normalizeProduct(product) {
    if (!product || typeof product !== 'object') return null;
    var variants = Array.isArray(product.variants)
      ? product.variants.filter(function (variant) {
          return variant && variant.id != null && Array.isArray(variant.options);
        })
      : [];
    if (!variants.length) return null;

    return Object.assign({}, product, {
      variants: variants,
      options: Array.isArray(product.options) ? product.options : []
    });
  }

  function imageSource(source, width) {
    if (!source) return '';
    var cleanSource = String(source).split(',')[0].trim().split(' ')[0];
    try {
      var url = new URL(cleanSource, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (error) {
      return cleanSource;
    }
  }

  function selectedCardImage(card) {
    var finish = card.querySelector('.evano-option-swatch[aria-pressed="true"]');
    if (finish && finish.dataset.evanoChoiceImage) return finish.dataset.evanoChoiceImage;

    var color = card.querySelector(
      '.t4s-pr-color__item.is-swatch--selected[data-img], ' +
      '.t4s-pr-color__item[aria-pressed="true"][data-img]'
    );
    if (color && color.dataset.img && color.dataset.img !== 'none') return color.dataset.img;

    var image = card.querySelector('.t4s-product-main-img, [data-main-img-change]');
    return image && (image.currentSrc || image.getAttribute('data-src') || image.src) || '';
  }

  function intentFromLink(link) {
    var card = link.closest('.t4s-product');
    if (!card) return null;

    var url = new URL(link.getAttribute('href') || '', window.location.origin);
    var handleMatch = url.pathname.match(/\/products\/([^/?#]+)/);
    var handle = handleMatch && decodeURIComponent(handleMatch[1]) || '';
    var variantId = card.dataset.evanoSelectedVariant ||
      link.dataset.variantId || url.searchParams.get('variant');
    if (!handle) return null;

    var finishImages = {};
    card.querySelectorAll('.evano-option-swatch[data-evano-choice-image]').forEach(function (swatch) {
      var label = swatch.dataset.evanoChoiceLabel;
      var image = swatch.dataset.evanoChoiceImage;
      if (!label || !image) return;
      finishImages[label] = image;
      if (label === 'Sin taches') finishImages.Ninguno = image;
    });

    return {
      variantId: variantId ? String(variantId) : '',
      image: selectedCardImage(card),
      finishImages: finishImages,
      handle: handle,
      sourceLink: link
    };
  }

  function captureQuickshopIntent(link) {
    if (!link) return;
    pendingIntent = intentFromLink(link);
    if (!pendingIntent) return;
    link.setAttribute('aria-busy', 'true');
    scheduleApply();
  }

  function activeQuickshop() {
    if (!document.documentElement.classList.contains('t4s-opening-qs')) return null;
    return Array.from(document.querySelectorAll('.t4s-product-quick-shop')).find(function (quickshop) {
      return quickshop.offsetParent !== null;
    }) || null;
  }

  function setQuickshopImage(quickshop, source) {
    var image = quickshop && quickshop.querySelector('[data-main-img-change]');
    if (!image || !source) return;

    var maxWidth = window.innerWidth < 768 ? 720 : 960;
    var widths = [320, 480, 640, 720, 800, 960].filter(function (width) {
      return width <= maxWidth;
    });
    var src = imageSource(source, maxWidth);
    var srcset = widths.map(function (width) {
      return imageSource(source, width) + ' ' + width + 'w';
    }).join(', ');
    var previewWidth = window.innerWidth < 768 ? 480 : 800;
    var previewSource = imageSource(source, previewWidth);

    var loader = quickshop.querySelector('.t4s-product-qs__img .lazyloadt4s-loader');
    if (loader) {
      loader.style.backgroundImage = 'url("' + previewSource + '")';
      loader.style.backgroundPosition = 'center center';
      loader.style.backgroundRepeat = 'no-repeat';
      loader.style.backgroundSize = 'contain';
    }

    var currentResolved = image.complete && image.naturalWidth > 8;
    if (!currentResolved) {
      quickshop.classList.add('is--evano-image-pending');
      quickshop.classList.remove('is--evano-image-ready');
    }
    if (image.dataset.evanoPendingSource === previewSource) return;
    image.dataset.evanoPendingSource = previewSource;

    var preload = new Image();
    preload.decoding = 'async';
    preload.fetchPriority = 'high';
    preload.onload = function () {
      if (image.dataset.evanoPendingSource !== previewSource) return;

      if (image.getAttribute('src') !== src) image.setAttribute('src', src);
      if (image.getAttribute('data-src') !== src) image.setAttribute('data-src', src);
      if (image.getAttribute('srcset') !== srcset) image.setAttribute('srcset', srcset);
      if (image.getAttribute('data-srcset') !== srcset) image.setAttribute('data-srcset', srcset);
      image.setAttribute('sizes', window.innerWidth < 768 ? '42vw' : '36vw');
      image.setAttribute('loading', 'eager');
      image.setAttribute('fetchpriority', 'high');
      image.setAttribute('decoding', 'async');

      var reveal = function () {
        if (image.dataset.evanoPendingSource !== previewSource) return;
        delete image.dataset.evanoPendingSource;
        quickshop.classList.remove('is--evano-image-pending');
        quickshop.classList.add('is--evano-image-ready');
      };
      if (typeof image.decode === 'function') image.decode().catch(function () {}).finally(reveal);
      else window.requestAnimationFrame(reveal);
    };
    preload.onerror = function () {
      if (image.dataset.evanoPendingSource === previewSource) {
        delete image.dataset.evanoPendingSource;
        quickshop.classList.remove('is--evano-image-pending');
      }
    };
    preload.src = previewSource;
  }

  function variantImage(variant) {
    if (!variant || !variant.featured_image) return '';
    return typeof variant.featured_image === 'string'
      ? variant.featured_image
      : variant.featured_image.src || '';
  }

  function optionLabel(option) {
    return typeof option === 'string' ? option : option && option.name || '';
  }

  function hydrateQuickshopImageSwatches(quickshop, product) {
    if (!quickshop || !product) return;
    var colorIndex = (product.options || []).findIndex(function (option) {
      return /color|colour|tono|lavado|estilo|acabado|desgaste|detalle|taches/i.test(optionLabel(option));
    });
    if (colorIndex < 0) {
      colorIndex = (product.options || []).findIndex(function (option) {
        return !/talla|size/i.test(optionLabel(option));
      });
    }
    if (colorIndex < 0) return;

    var colorGroup = Array.from(quickshop.querySelectorAll('[data-swatch-option]')).find(function (group) {
      return Number(group.dataset.id) === colorIndex;
    });
    if (!colorGroup) return;

    colorGroup.querySelectorAll('[data-swatch-item]').forEach(function (swatch) {
      var value = swatch.dataset.value;
      var matchingVariant = (product.variants || []).find(function (variant) {
        return variant.options && variant.options[colorIndex] === value && variantImage(variant);
      });
      var source = variantImage(matchingVariant);
      if (!source) return;

      swatch.classList.add('is--evano-image-swatch');
      swatch.dataset.evanoVariantImage = imageSource(source, 960);
      swatch.style.setProperty('--evano-swatch-image', 'url("' + imageSource(source, 180) + '")');
      swatch.setAttribute('aria-label', value);
    });

    colorGroup.classList.add('is--evano-image-swatches-ready');
  }

  function prepareQuickshop(quickshop) {
    if (!quickshop || !pendingIntent || pendingIntent.productRequested) return;
    var intent = pendingIntent;
    intent.productRequested = true;
    var embeddedProduct = embeddedQuickshopProduct(quickshop);
    var productRequest = embeddedProduct
      ? Promise.resolve(embeddedProduct)
      : productData(intent.handle);
    productRequest.then(function (product) {
      if (!product || pendingIntent !== intent) return;
      hydrateQuickshopImageSwatches(quickshop, product);

      var variants = product.variants || [];
      var selectedVariant = variants.find(function (variant) {
        return String(variant.id) === String(intent.variantId);
      }) || variants.find(function (variant) {
        return variant.available;
      }) || variants[0];
      if (selectedVariant) intent.variantId = String(selectedVariant.id);
      var selectedImage = variantImage(selectedVariant);
      if (selectedImage) intent.image = selectedImage;
      setQuickshopImage(quickshop, intent.image);
      scheduleApply();
    });
  }

  function embeddedQuickshopProduct(quickshop) {
    var payload = quickshop && quickshop.querySelector('[data-evano-quickshop-product]');
    if (!payload || payload.dataset.evanoParsed === 'error') return null;
    if (payload.evanoProduct) return payload.evanoProduct;

    try {
      payload.evanoProduct = normalizeProduct(JSON.parse(payload.textContent));
      if (!payload.evanoProduct) throw new Error('Invalid quick-shop product payload');
      return payload.evanoProduct;
    } catch (error) {
      payload.dataset.evanoParsed = 'error';
      return null;
    }
  }

  function applyIntent() {
    scheduled = false;
    if (!pendingIntent || resolvingChoice) return;

    var quickshop = activeQuickshop();
    if (!quickshop) return;

    var selector = quickshop.querySelector('select[name="id"]');
    if (!pendingIntent.variantId && selector && selector.value) {
      pendingIntent.variantId = String(selector.value);
    }

    var embeddedProduct = embeddedQuickshopProduct(quickshop);
    if (embeddedProduct) {
      hydrateQuickshopImageSwatches(quickshop, embeddedProduct);
      var selectedVariant = (embeddedProduct.variants || []).find(function (variant) {
        return String(variant.id) === String(pendingIntent.variantId);
      });
      var selectedImage = variantImage(selectedVariant);
      if (selectedImage) pendingIntent.image = selectedImage;
    }

    prepareQuickshop(quickshop);
    setQuickshopImage(quickshop, pendingIntent.image);

    var option = selector && Array.from(selector.options).find(function (item) {
      return item.value === pendingIntent.variantId;
    });
    if (!selector || !option) return;

    if (selector.value !== pendingIntent.variantId) {
      selector.value = pendingIntent.variantId;
      selector.dispatchEvent(new Event('change', { bubbles: true }));
    }

    setQuickshopImage(quickshop, pendingIntent.image);
    quickshop.dataset.evanoQuickshopVariant = pendingIntent.variantId;
    quickshop.classList.add('is--evano-editorial-ready');
  }

  function hydrateVisibleQuickshop(quickshop) {
    if (!quickshop || !pendingIntent) return;

    var selector = quickshop.querySelector('select[name="id"]');
    if (!selector) return;
    if (!pendingIntent.variantId) pendingIntent.variantId = String(selector.value || '');

    var product = embeddedQuickshopProduct(quickshop);
    if (product) {
      hydrateQuickshopImageSwatches(quickshop, product);
      var variant = (product.variants || []).find(function (item) {
        return String(item.id) === String(pendingIntent.variantId);
      });
      var source = variantImage(variant);
      if (source) pendingIntent.image = source;
    }

    var option = Array.from(selector.options).find(function (item) {
      return item.value === pendingIntent.variantId;
    });
    if (!option) return;
    if (selector.value !== pendingIntent.variantId) {
      selector.value = pendingIntent.variantId;
      selector.dispatchEvent(new Event('change', { bubbles: true }));
    }

    setQuickshopImage(quickshop, pendingIntent.image);
    quickshop.dataset.evanoQuickshopVariant = pendingIntent.variantId;
    quickshop.classList.add('is--evano-editorial-ready');
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(applyIntent);
    });
  }

  function productData(handle) {
    if (!handle) return Promise.resolve(null);
    var request = productCache.get(handle);
    if (!request) {
      request = requestProductData(handle, 0)
        .then(function (product) {
          product = normalizeProduct(product);
          if (!product) throw new Error('Invalid product payload');
          preloadProductImages(product);
          return product;
        })
        .catch(function () {
          productCache.delete(handle);
          return null;
        });
      productCache.set(handle, request);
    }
    return request;
  }

  function requestProductData(handle, attempt) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (response.ok) return response.json();
      if (response.status !== 429 || attempt >= 3) {
        throw new Error('Product data request failed (' + response.status + ')');
      }

      var retryAfter = Number.parseFloat(response.headers.get('Retry-After'));
      var retryDelays = [500, 1100, 2200];
      var delay = Number.isFinite(retryAfter)
        ? Math.max(retryAfter * 1000, retryDelays[attempt])
        : retryDelays[attempt];
      return new Promise(function (resolve) {
        window.setTimeout(resolve, delay);
      }).then(function () {
        return requestProductData(handle, attempt + 1);
      });
    });
  }

  function preloadProductImages(product) {
    var seen = new Set();
    var previewWidth = window.innerWidth < 768 ? 480 : 640;
    (product && product.variants || []).some(function (variant) {
      var source = variantImage(variant);
      if (!source || seen.has(source)) return false;
      seen.add(source);
      var image = new Image();
      image.decoding = 'async';
      image.src = imageSource(source, previewWidth);
      return seen.size >= 3;
    });
  }

  function handleFromQuickshopLink(link) {
    var url = new URL(link.getAttribute('href') || '', window.location.origin);
    var handleMatch = url.pathname.match(/\/products\/([^/?#]+)/);
    return handleMatch ? decodeURIComponent(handleMatch[1]) : '';
  }

  function intentFromQuickshop(quickshop) {
    var detailLink = quickshop && quickshop.querySelector(
      '.t4s-pr__btn-detail[href*="/products/"], a[href*="/products/"]'
    );
    var handle = detailLink && handleFromQuickshopLink(detailLink);
    if (!handle) return null;

    var image = quickshop.querySelector('[data-main-img-change]');
    var selector = quickshop.querySelector('select[name="id"]');
    return {
      variantId: selector && selector.value || '',
      image: image && (image.currentSrc || image.getAttribute('data-src') || image.src) || '',
      finishImages: {},
      handle: handle,
      sourceLink: null
    };
  }

  function warmQuickshopLink(link) {
    if (!link || warmedQuickshopLinks.has(link)) return;
    warmedQuickshopLinks.add(link);
    var handle = handleFromQuickshopLink(link);
    if (!handle || productCache.has(handle) || productWarmQueue.includes(handle)) return;
    productWarmQueue.push(handle);
    drainProductWarmQueue();
  }

  function drainProductWarmQueue() {
    while (activeProductWarms < maxConcurrentProductWarms && productWarmQueue.length) {
      var handle = productWarmQueue.shift();
      if (productCache.has(handle)) continue;
      activeProductWarms += 1;
      productData(handle).finally(function () {
        activeProductWarms -= 1;
        drainProductWarmQueue();
      });
    }
  }

  function observeQuickshopLinks(root) {
    var links = new Set(root.querySelectorAll?.(quickshopLinkSelector) || []);
    if (root.matches?.(quickshopLinkSelector)) links.add(root);
    links.forEach(function (link) {
      if (quickshopPreloadObserver) quickshopPreloadObserver.observe(link);
      else warmQuickshopLink(link);
    });
  }

  function syncIntentFromQuickshop(quickshop, clickedSwatch) {
    var selector = quickshop.querySelector('select[name="id"]');
    var variantId = selector && selector.value;
    if (!variantId || !pendingIntent) return;

    var revision = ++choiceRevision;
    resolvingChoice = true;
    var applyProductChoice = function (product) {
      if (!product || !pendingIntent || revision !== choiceRevision) return;

      hydrateQuickshopImageSwatches(quickshop, product);

      var variants = product.variants || [];
      var currentVariant = variants.find(function (item) {
        return String(item.id) === String(variantId);
      });
      var optionValues = currentVariant && currentVariant.options
        ? currentVariant.options.slice()
        : [];
      var groups = Array.from(quickshop.querySelectorAll('[data-swatch-option]'));

      groups.forEach(function (group, index) {
        var selected = group.querySelector('[data-swatch-item].is--selected');
        if (selected && selected.dataset.value) optionValues[index] = selected.dataset.value;
      });

      var clickedGroup = clickedSwatch && clickedSwatch.closest('[data-swatch-option]');
      var clickedIndex = groups.indexOf(clickedGroup);
      if (clickedIndex >= 0 && clickedSwatch.dataset.value) {
        optionValues[clickedIndex] = clickedSwatch.dataset.value;
      }

      var variant = variants.find(function (item) {
        return (item.options || []).every(function (value, index) {
          return value === optionValues[index];
        });
      }) || currentVariant;
      if (!variant) return;

      pendingIntent.variantId = String(variant.id);
      var selectedVariantImage = variantImage(variant);
      var clickedValue = clickedSwatch && clickedSwatch.dataset.value;
      var curatedImage = clickedValue && pendingIntent.finishImages &&
        pendingIntent.finishImages[clickedValue];
      if (curatedImage) pendingIntent.image = curatedImage;
      else if (selectedVariantImage) pendingIntent.image = selectedVariantImage;

      selector.value = pendingIntent.variantId;
      selector.dispatchEvent(new Event('change', { bubbles: true }));
      setQuickshopImage(quickshop, pendingIntent.image);
      quickshop.dataset.evanoQuickshopVariant = pendingIntent.variantId;
      quickshop.classList.add('is--evano-editorial-ready');
    };
    var finishChoice = function () {
      if (revision === choiceRevision) resolvingChoice = false;
      hydrateVisibleQuickshop(quickshop);
      scheduleApply();
    };

    var embeddedProduct = embeddedQuickshopProduct(quickshop);
    if (embeddedProduct) {
      applyProductChoice(embeddedProduct);
      finishChoice();
      return;
    }

    productData(pendingIntent.handle).then(applyProductChoice).finally(finishChoice);
  }

  function queueQuickshopSwatchSync(swatch) {
    if (!swatch) return;
    var quickshop = swatch.closest('.t4s-product-quick-shop');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        syncIntentFromQuickshop(quickshop, swatch);
      });
    });
  }

  function commitSelectedSwatch(quickshop, selectedSwatch) {
    var product = embeddedQuickshopProduct(quickshop);
    var selector = quickshop && quickshop.querySelector('select[name="id"]');
    if (!product || !selector || !selectedSwatch) return false;

    var currentVariant = (product.variants || []).find(function (variant) {
      return String(variant.id) === String(selector.value);
    });
    var optionValues = currentVariant && currentVariant.options
      ? currentVariant.options.slice()
      : [];
    var groups = Array.from(quickshop.querySelectorAll('[data-swatch-option]'));
    groups.forEach(function (group, index) {
      var chosen = group.querySelector('[data-swatch-item].is--selected');
      if (chosen && chosen.dataset.value) optionValues[index] = chosen.dataset.value;
    });

    var selectedGroup = selectedSwatch.closest('[data-swatch-option]');
    var selectedIndex = groups.indexOf(selectedGroup);
    if (selectedIndex >= 0) optionValues[selectedIndex] = selectedSwatch.dataset.value;

    var variant = (product.variants || []).find(function (item) {
      return (item.options || []).every(function (value, index) {
        return value === optionValues[index];
      });
    });
    if (!variant) return false;

    if (!pendingIntent) pendingIntent = intentFromQuickshop(quickshop);
    if (!pendingIntent) return false;
    pendingIntent.variantId = String(variant.id);
    var source = variantImage(variant);
    if (source) pendingIntent.image = source;

    selector.value = pendingIntent.variantId;
    selector.dispatchEvent(new Event('change', { bubbles: true }));
    setQuickshopImage(quickshop, pendingIntent.image);
    quickshop.dataset.evanoQuickshopVariant = pendingIntent.variantId;
    quickshop.classList.add('is--evano-editorial-ready');
    return true;
  }

  function observeQuickshopChoices(quickshop) {
    if (!quickshop || quickshop.dataset.evanoChoiceObserver === 'true') return;
    quickshop.dataset.evanoChoiceObserver = 'true';

    new MutationObserver(function (mutations) {
      var selectedSwatch = mutations.map(function (mutation) {
        return mutation.target;
      }).find(function (target) {
        return target.matches?.('[data-swatch-item].is--selected');
      });
      if (!selectedSwatch) return;

      var group = selectedSwatch.closest('[data-swatch-option]');
      var signature = (group && group.dataset.id || '') + ':' +
        (selectedSwatch.dataset.value || '');
      if (quickshop.dataset.evanoLastChoice === signature) return;
      quickshop.dataset.evanoLastChoice = signature;
      if (commitSelectedSwatch(quickshop, selectedSwatch)) return;
      queueQuickshopSwatchSync(selectedSwatch);
    }).observe(quickshop, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest(quickshopLinkSelector);
    if (link) {
      captureQuickshopIntent(link);
      return;
    }

    var swatch = event.target.closest('.t4s-product-quick-shop [data-swatch-item]');
    if (!swatch) return;
    queueQuickshopSwatchSync(swatch);
  }, true);

  document.addEventListener('pointerdown', function (event) {
    captureQuickshopIntent(event.target.closest?.(quickshopLinkSelector));
  }, { capture: true, passive: true });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var link = event.target.closest?.(quickshopLinkSelector);
    if (link) {
      captureQuickshopIntent(link);
      return;
    }
    queueQuickshopSwatchSync(
      event.target.closest?.('.t4s-product-quick-shop [data-swatch-item]')
    );
  }, true);

  document.addEventListener('pointerup', function (event) {
    queueQuickshopSwatchSync(
      event.target.closest?.('.t4s-product-quick-shop [data-swatch-item]')
    );
  }, { capture: true, passive: true });

  ['pointerover', 'focusin', 'touchstart'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      warmQuickshopLink(event.target.closest?.(quickshopLinkSelector));
    }, { capture: true, passive: true });
  });

  function observeQuickshop() {
    observeQuickshopLinks(document);
    var syncQuickshopState = function () {
      var quickshop = activeQuickshop();
      if (!quickshop) {
        pendingIntent && pendingIntent.sourceLink && pendingIntent.sourceLink.removeAttribute('aria-busy');
        return;
      }
      var inferredIntent = intentFromQuickshop(quickshop);
      if (inferredIntent && (!pendingIntent || pendingIntent.handle !== inferredIntent.handle)) {
        pendingIntent = inferredIntent;
      }
      if (pendingIntent && pendingIntent.sourceLink) {
        pendingIntent.sourceLink.removeAttribute('aria-busy');
      }
      observeQuickshopChoices(quickshop);
      hydrateVisibleQuickshop(quickshop);
      scheduleApply();
    };

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) observeQuickshopLinks(node);
        });
      });
      syncQuickshopState();
    }).observe(document.body, {
      childList: true,
      subtree: true
    });

    new MutationObserver(syncQuickshopState).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeQuickshop, { once: true });
  } else {
    observeQuickshop();
  }
})();

/* EVANO — reliable mobile mini-cart removal with a single cart mutation. */
(function () {
  var mobile = window.matchMedia('(max-width: 767px)');
  var removingKeys = new Set();

  function wait(delay) {
    return new Promise(function (resolve) { window.setTimeout(resolve, delay); });
  }

  function updateCartCount(count) {
    document.documentElement.classList.toggle('t4s-cart-count-0', count === 0);
    document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
      badge.textContent = String(count);
      badge.dataset.cartCountValue = String(count);
      badge.hidden = count === 0;
      badge.setAttribute('aria-hidden', String(count === 0));
      badge.classList.toggle('t4s-op-0', count === 0);
    });
  }

  function replaceMiniCart(sectionHtml, count) {
    if (!sectionHtml || !('DOMParser' in window)) return false;
    var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var freshDrawer = parsed.querySelector('#t4s-mini_cart');
    var currentDrawer = document.querySelector('#t4s-mini_cart');
    if (!freshDrawer || !currentDrawer) return false;
    currentDrawer.innerHTML = freshDrawer.innerHTML;
    currentDrawer.dataset.ccount = String(count);
    return true;
  }

  async function removeCartLine(key) {
    var root = window.Shopify?.routes?.root || '/';
    var retryDelays = [650, 1400, 2600];
    var response = null;

    for (var attempt = 0; attempt <= retryDelays.length; attempt += 1) {
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 10000);

      try {
        response = await fetch(root + 'cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: key,
            quantity: 0,
            sections: ['mini_cart'],
            sections_url: window.location.pathname
          }),
          signal: controller.signal
        });
      } finally {
        window.clearTimeout(timeout);
      }

      if (response.status !== 429 || attempt === retryDelays.length) return response;

      var retryAfter = Number.parseFloat(response.headers.get('Retry-After'));
      await wait(Number.isFinite(retryAfter)
        ? Math.max(retryAfter * 1000, retryDelays[attempt])
        : retryDelays[attempt]);
    }

    return response;
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest?.('#t4s-mini_cart [data-cart-remove]');
    if (!remove || !mobile.matches) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var key = remove.dataset.id;
    if (!key || removingKeys.has(key)) return;
    removingKeys.add(key);

    var item = remove.closest('[data-cart-item]');
    item?.classList.add('is--evano-removing');
    item?.setAttribute('aria-busy', 'true');
    remove.setAttribute('aria-disabled', 'true');

    removeCartLine(key)
      .then(function (response) {
        if (!response || !response.ok) throw new Error('Cart removal failed');
        return response.json();
      })
      .then(function (cart) {
        var count = Number(cart.item_count) || 0;
        updateCartCount(count);
        replaceMiniCart(cart.sections?.mini_cart, count);
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: { source: 'evano-mobile-remove', cart: cart }
        }));
      })
      .catch(function () {
        window.location.assign(remove.href);
      })
      .finally(function () {
        removingKeys.delete(key);
        if (!item?.isConnected) return;
        item.classList.remove('is--evano-removing');
        item.removeAttribute('aria-busy');
        remove.removeAttribute('aria-disabled');
      });
  }, true);
})();
